import React from 'react'
import history from '../../../lib/history'
import routes from '../../../config/routes'
import Text from '../../commons/Text/Text'
import RegisterEmailForm from './RegisterEmailForm'
import ExternalLayout from '../../commons/Layouts/ExternalLayout'
import FlameSantander from '../../commons/Icons/FlameSantander'
import styles from './registerAlterEmail.module.scss'

const RegisterEmailContainer = () => {
  const handleSubmit = (values) => {
    // eslint-disable-next-line no-console
    console.log(values)

    history.push(routes.registerPhone.path)
  }

  return (
    <ExternalLayout>
      <div className={styles.container}>
        <FlameSantander />
        <Text
          color="gray"
          variation="dark"
          size="lg"
          bold
          inline
          margin="10px 0px"
        >
          Alterar endereço de e-mail.
        </Text>
        {/* <Text color="gray" variation="dark" size="md" margin="10px 0px">
          E-mail atual thaoliveira@santander.com.br.
        </Text> */}
      </div>

      <RegisterEmailForm handleSubmit={handleSubmit} />
    </ExternalLayout>
  )
}

export default RegisterEmailContainer
